import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ArtifactUploadFieldsSchema, ReleaseArtifactSchema } from './shapes';

export const finalizeReleaseUpload = defineEndpoint({
  method: 'POST',
  path: '/v1/release-uploads/finalize',
  params: z.object({}),
  query: z.object({}),
  body: ArtifactUploadFieldsSchema.extend({ storagePath: z.string().min(1).max(500) }),
  response: z.object({ data: ReleaseArtifactSchema }),
  successStatus: 201,
});
